var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuickCommand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75193 8.44905H5.44596C4.4568 8.44905 3.96222 8.44905 3.75141 8.12296C3.5406 7.79686 3.74146 7.34253 4.1432 6.43388L5.35096 3.70215C5.71622 2.876 5.89885 2.46292 6.25315 2.23146C6.60745 2 7.05713 2 7.95648 2H9.34943C10.442 2 10.9882 2 11.1943 2.3569C11.4003 2.7138 11.1293 3.19058 10.5872 4.14415L9.87264 5.40125C9.60317 5.8753 9.46844 6.11232 9.47032 6.30635C9.47276 6.5585 9.60686 6.79079 9.82343 6.91803C9.99008 7.01593 10.2616 7.01593 10.8048 7.01593C11.4914 7.01593 11.8347 7.01593 12.0135 7.13478C12.2458 7.28919 12.3674 7.56546 12.3248 7.84212C12.292 8.05506 12.061 8.31042 11.5992 8.82113L7.90908 12.9016C7.1843 13.703 6.82191 14.1037 6.57855 13.9769C6.33519 13.8501 6.45206 13.3214 6.68579 12.2641L7.14362 10.1931C7.32159 9.38798 7.41058 8.98543 7.19657 8.71724C6.98256 8.44905 6.57235 8.44905 5.75193 8.44905Z",
    stroke: "#3D3D43",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuickCommand);
export default __webpack_public_path__ + "static/media/icon-quick-command.f2980e0b38ade4e1cc6451618c9df0df.svg";
export { ForwardRef as ReactComponent };